// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"362":"c6edcddb","476":"4ca3c27b","945":"140ce0ff","950":"11fb1930"}[chunkId] + ".css";
};